/**
 * Extracts x-axis category labels from raw dashboard API items.
 * Supports both the real API `range` field (day/week/month/year groupBy)
 * and the legacy `date` field used in older mock data.
 * Returns a plain data object — no chart library dependency.
 */
export const chartOptions = (items: any[]): { xaxis: { categories: string[] } } => {
  return {
    xaxis: {
      categories: (items ?? []).map((item) => item?.range ?? item?.date ?? ''),
    },
  };
};
